import { useState, useEffect } from 'react';
import ApiService from '../../../../services/api'
import DOMPurify from "dompurify";

const LegalNotes = () => {
  

  const [legalNotes, setLegalNotes] = useState('');

  useEffect(() => {
      const fetchLegalNotes = async () => {
        try {
          const res = await ApiService.getLegal();
          setLegalNotes(res.legal_notes); 
        } catch (err) {
          console.error('Errore nel recupero delle note legali:', err);
        }
      };
      fetchLegalNotes();
    },[]);

    return (
        <div>
            <h2 style={{marginBottom: "50px", marginTop: "10px"}}>Note Legali</h2>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(legalNotes || "") }} />
        </div>

    );

  }

export default LegalNotes;